window.SDK = require('../../distrib/Speech.Browser.Sdk.js')


//////////////////
// WEBPACK FOOTER
// ./samples/browser/sample_app.js
// module id = 17
// module chunks = 0